import React, { Component } from 'react'
import Link from '../utils/link'

class TitleContentButton extends Component {

  render() {
    const { title, content, button } = this.props

    return (
      <>
        <section className='title-content-button' data-color='#FFF'>
          <div className='title-content-button__inner'>
            <div className='title-content-button__wrapper'>
              <h1 dangerouslySetInnerHTML={{ __html: title }} />
              <div className='title-content-button__content' dangerouslySetInnerHTML={{ __html: content }} />
              { button.link && <Link to={button.link} className='btn'>{button.text}</Link> }
            </div>
          </div>
        </section>
      </>
    )
  }
}

export default TitleContentButton
